import React, { useContext } from 'react';
import styles from './Header.module.css';
import Avatar from '../Avatar/Avatar';
import SocialLinks from '../SocialLinks/SocialLinks';
import getProfileData from '../../data/profileData';
import { LanguageContext } from '../../contexts/LanguageContext';

const Header = () => {
  const { language } = useContext(LanguageContext);
  const { name, description, socialLinks } = getProfileData(language);

  return (
    <header className={styles.header}>
      <div className={styles.headerContent}>
        <Avatar />
        <div className={styles.headerText}>
          <h1 className={styles.name}>{name}</h1>
          <p className={styles.description}>{description}</p>
          <SocialLinks links={socialLinks} />
        </div>
      </div>
    </header>
  );
};

export default Header;